/**
 * 
 */
export default [
    {
        text        : 'N° DE REGISTRO',
        value       : 'id',
    },
    {
        text        : 'CLIENTE',
        fieldType   : 'computed',
        value       : ({ sl_customer }) => sl_customer.business_name,
    },
    {
        text        : 'RESPONSABLE',
        value       : ({ g_user }) => g_user.hr_employee.names + ' ' + g_user.hr_employee.last_name1 + ' ' + g_user.hr_employee.last_name2,
    },
    {
        text        : 'SUCURSAL',
        value       : ({ pos_cash_desk }) => pos_cash_desk.g_branch_office.address,
    },
    {
        text        : 'PAGOS',
        value       : ({ transformed_payments }) => transformed_payments.length,
    },
    {
        text        : 'TOTAL',
        format      : 'currency',
        value       : 'total',
    },
    {
        text        : 'FECHA DE CREACIÓN',
        value       : 'created_at',
    },
    {
        text        : 'FECHA DE MODIFICACIÓN',
        value       : 'updated_at',
    },
]
